import React from 'react';
import './ConfigDetails.css';

const ConfigDetails = ({ config }) => {
  // Helper pentru a obține numele modelului
  const getModelName = () => {
    switch (config.selectedModel) {
      case 'tip1': return 'Eco-Insulă Tip 1';
      case 'tip2': return 'Eco-Insulă Tip 2';
      case 'tip3': return 'Eco-Insulă Tip 3';
      default: return 'Necunoscut';
    }
  };

  // Helper pentru a obține fracțiile selectate cu cantități și volume pentru tip2
  const getFractionsString = () => {
    const selectedFractions = Object.entries(config.fractions)
      .filter(([_, fraction]) => fraction.enabled)
      .map(([name, fraction]) => {
        let fractionName;
        switch (name) {
          case 'residual':      fractionName = 'Rezidual';      break;
          case 'glass':         fractionName = 'Sticlă';        break;
          case 'plastic':       fractionName = 'Plastic';       break;
          case 'paper':         fractionName = 'Hârtie';        break;
          case 'biodegradable': fractionName = 'Biodegradabil'; break;
          default:              fractionName = name;
        }

        let fractionDetails = `${fractionName} (${fraction.quantity || 1} buc)`;

        if (
          config.selectedModel === 'tip2' &&
          (name === 'plastic' || name === 'paper') &&
          fraction.volume
        ) {
          fractionDetails += ` - ${fraction.volume}L`;
        }

        return fractionDetails;
      });

    return selectedFractions.join(', ');
  };

  // Helper pentru a obține tipul de așezare
  const getLayoutType = () => {
    switch (config.layout) {
      case 'linear':       return 'Liniară';
      case 'L-shape':      return 'Tip L';
      case 'U-shape':      return 'Tip U';
      case 'back-to-back': return 'Spate în spate';
      default:             return 'Necunoscut';
    }
  };

  // Helper pentru detalii tambur
  const getDrumDetails = () => {
    const fractionDetails = Object.entries(config.fractions)
      .filter(([_, fraction]) => fraction.enabled)
      .map(([name, fraction]) => {
        let fractionName;
        switch (name) {
          case 'residual':      fractionName = 'Rezidual';      break;
          case 'glass':         fractionName = 'Sticlă';        break;
          case 'plastic':       fractionName = 'Plastic';       break;
          case 'paper':         fractionName = 'Hârtie';        break;
          case 'biodegradable': fractionName = 'Biodegradabil'; break;
          default:              fractionName = name;
        }

        const drumTypeText =
          fraction.drumType === 'single' ? 'Tambur simplu' : 'Tambur dublu';

        return `${fractionName}: ${drumTypeText}`;
      });

    return fractionDetails.join(', ');
  };

  // Helper pentru cantități
  const getQuantityDetails = () => {
    const quantityDetails = Object.entries(config.fractions)
      .filter(([_, fraction]) => fraction.enabled)
      .map(([name, fraction]) => {
        let fractionName;
        switch (name) {
          case 'residual':      fractionName = 'Rezidual';      break;
          case 'glass':         fractionName = 'Sticlă';        break;
          case 'plastic':       fractionName = 'Plastic';       break;
          case 'paper':         fractionName = 'Hârtie';        break;
          case 'biodegradable': fractionName = 'Biodegradabil'; break;
          default:              fractionName = name;
        }

        return `${fractionName}: ${fraction.quantity || 1} buc`;
      });

    return quantityDetails.join(', ');
  };

  // Helper pentru tip cârlig
  const getHookType = () => {
    if (!config.hookType) return '';
    switch (config.hookType) {
      case 'simplu':        return 'Cârlig Simplu';
      case 'dublu-linie':   return 'Dublu cârlig în linie';
      case 'dublu-paralel': return 'Dublu cârlig în paralel';
      case 'ciuperca':      return 'Cârlig tip Ciupercă';
      default:              return 'Necunoscut';
    }
  };

  // Helper pentru aranjament spațial (folosim config.arrangement)
  const getArrangementType = () => {
    switch (config.arrangement) {
      case 'individual': return 'Eco-insule individuale';
      case 'grouped':    return 'Eco-insule grupate';
      case 'custom':     return 'Configurare personalizată';
      default:           return 'Necunoscut';
    }
  };

  // Helper pentru accesorii
  const getAccessoriesString = () => {
    const accessories = [];
    if (config.accessories?.colantare) accessories.push('Colantare');
    return accessories.join(', ');
  };

  // Helper pentru opțiuni de alimentare
  const getPowerOptionsString = () => {
    if (!config.powerType) return 'Nedefinit';

    if (config.powerType === 'nonElectric') {
      return 'Varianta fără curent - Cu deschidere mecanică';
    }

    let result = 'Varianta electrică - ';

    if (config.electricOption === 'independent') {
      result += 'Independentă (autonomă)';
    } else if (config.electricOption === 'grid-connected') {
      result += 'Legată la sursă de curent';
    } else {
      return result + 'Nespecificat';
    }

    if (config.accessOption === 'with-it-platform') {
      result += ' - Cu acces la platformă IT';
    } else if (config.accessOption === 'without-it-platform') {
      result += ' - Fără acces la platformă IT (cu cartelă)';
    }

    return result;
  };

  // Helper pentru funcționalitățile platformei
  const getPlatformFeaturesString = () => {
    if (
      config.powerType !== 'electric' ||
      config.accessOption !== 'with-it-platform' ||
      !config.platformFeatures
    ) {
      return '';
    }

    const enabledFeatures = config.platformFeatures
      .filter(feature => feature.enabled)
      .map(feature => feature.label);

    return enabledFeatures.join(', ');
  };

  return (
    <div className="config-details">
      <div className="details-header">
        <h3>Detalii configurație</h3>

        {/* Badge județ */}
        <span
          className={`judet-badge ${
            config.judet ? 'judet-ok' : 'judet-empty'
          }`}
        >
          {config.judet || 'Neselectat'}
        </span>
      </div>

      <ul className="details-list">
        <li>
          <span className="detail-label">Model selectat:</span>
          <span className="detail-value">{getModelName()}</span>
        </li>

        <li>
          <span className="detail-label">Județ:</span>
          <span className="detail-value">{config.judet || 'Neselectat'}</span>
        </li>

        <li>
          <span className="detail-label">Fracții:</span>
          <span className="detail-value">{getFractionsString()}</span>
        </li>

        <li>
          <span className="detail-label">Tipuri tambur:</span>
          <span className="detail-value">{getDrumDetails()}</span>
        </li>

        <li>
          <span className="detail-label">Cantități fracții:</span>
          <span className="detail-value">{getQuantityDetails()}</span>
        </li>

        <li>
          <span className="detail-label">Alimentare:</span>
          <span className="detail-value">{getPowerOptionsString()}</span>
        </li>

        {config.powerType === 'electric' &&
          config.accessOption === 'with-it-platform' && (
            <li>
              <span className="detail-label">Funcționalități platformă:</span>
              <span className="detail-value">
                {getPlatformFeaturesString() || 'Neselectate'}
              </span>
            </li>
          )}

        {config.selectedModel === 'tip1' && (
          <li>
            <span className="detail-label">Așezare:</span>
            <span className="detail-value">{getLayoutType()}</span>
          </li>
        )}

        {/* Aranjament spațial (pentru toate modelele, dacă e setat) */}
        {config.arrangement && (
          <li>
            <span className="detail-label">Aranjament spațial:</span>
            <span className="detail-value">{getArrangementType()}</span>
          </li>
        )}

        {(config.selectedModel === 'tip2' ||
          config.selectedModel === 'tip3') &&
          config.hookType && (
            <li>
              <span className="detail-label">Tip cârlig:</span>
              <span className="detail-value">{getHookType()}</span>
            </li>
          )}

        {config.accessories?.colantare && (
          <li>
            <span className="detail-label">Accesorii:</span>
            <span className="detail-value">{getAccessoriesString()}</span>
          </li>
        )}

        {config.additionalDetails && (
          <li>
            <span className="detail-label">Detalii suplimentare:</span>
            <span className="detail-value">{config.additionalDetails}</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default ConfigDetails;
